import type { UseQueryResult } from '@tanstack/react-query';

import { makeAsync } from './async';
import type { Async } from './types';

type AsyncSource<TData> = Pick<
  UseQueryResult<TData>,
  'isError' | 'error' | 'data' | 'fetchStatus'
>;

/**
 * A disabled query in react-query v4 reports `status === 'loading'` with
 * `fetchStatus === 'idle'`, so `not-fetched` has to be decided before the
 * fetching fallback or it becomes unreachable.
 */
export const toAsync = <TData, TError>(
  query: AsyncSource<TData>,
  toError: (error: unknown) => TError,
): Async<TData, TError> => {
  if (query.isError) return makeAsync.error(toError(query.error));
  if (query.data !== undefined) return makeAsync.fetched(query.data);
  if (query.fetchStatus === 'idle') return makeAsync.notFetched();
  return makeAsync.fetching();
};
